import { render, staticRenderFns } from "./ProjectPixConfigModal.vue?vue&type=template&id=c0bb7c9c&scoped=true"
import script from "./ProjectPixConfigModal.vue?vue&type=script&lang=js"
export * from "./ProjectPixConfigModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0bb7c9c",
  null
  
)

export default component.exports